import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=1a8bedb8&scoped=true&"
import script from "./eventDetail.vue?vue&type=script&lang=js&"
export * from "./eventDetail.vue?vue&type=script&lang=js&"
import style0 from "./eventDetail.vue?vue&type=style&index=0&id=1a8bedb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8bedb8",
  null
  
)

export default component.exports